import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";

const PlanifLines = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [deliveryDate, setdeliveryDate] = useState("");
    const [nestedDate, setnestedDate] = useState("");
    const [serviceType, setserviceType] = useState("");
    const [project, setproject] = useState("");
    const [servicesType, setServicesType] = useState("");
    const [start_route, setStartRoute] = useState("");
    const [end_route, setEndRoute] = useState("");
    const [school, setSchool] = useState("");
    const [raciones, setQuantity] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);
    const [schools, setSchools] = useState([]);

     // Obtener la lista de artículos desde el backend
    const fetchItems = async () => {
        try {
            const responsePro = await apiClient.get("/sales-orders/projects");
            const responseSch = await apiClient.get("/sales-orders/schools");
            
            // Valores estáticos
            const staticItems = [
                { value: "DES", label: "Desayuno" },
                { value: "ALM", label: "Almuerzo" },
                { value: "MER", label: "Merienda" },
                { value: "CEN", label: "Cena" },
                { value: "LIM", label: "LIMPIEZA" },
                { value: "UTE", label: "UTENSILIOS" },
                { value: "EQU", label: "EQUIPAMIENTOS" },
            ];
            setServicesType(staticItems);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedSchools = responseSch.data.map((item) => ({
                value: item.CntctCode,
                label: `${item.Name}`,
            }));
            setSchools(formattedSchools);

        } catch (err) {
            console.error("Error obteniendo datos", err);
            setError("Error al obtener los datos.");
        }
    };

    // Función para obtener datos desde el backend
    const fetchInsumos = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get("/planif/insumos/escuelas", {
                params: { project: project?.value || "", servicio: serviceType?.value || "", startDate, endDate,  start_route, end_route, raciones, school: school?.value || "" }
            });

            console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                    key = `${order.DocEntry}`;


                if (!acc[key]) {
                    acc[key] = {
                        CardCode: order.CardCode, 
                        CntctCode: order.IdEscuela,
                        Institucion: order.Name,
                        Ruta: order.Ruta,
                        MesEntrega: order.MesEntrega,
                        Semana: order.Semana,
                        Project: order.Project,
                        Localidad: order.Localidad,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    // 🔍 Filtrado dinámico
    useEffect(() => {
        fetchItems();
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const filteredData = orders.filter((order) =>
            (order.CardName ? order.CardName.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.Name ? order.Name.toLowerCase() : "").includes(searchTerm.toLowerCase())
        );

        setFilteredOrders(filteredData);
    }, [searchTerm, orders]);

    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6 style={{ fontSize: "12px" }}>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Insumo</th>
                        <th>Descripción</th>
                        <th>Cantidad a Planificar</th>
                        <th>Cantidad Real</th>
                        <th>Precio</th>
                        <th>Fecha Necesaria</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Orders.map((order, index) => (
                        <tr key={index}>
                            <td>{order.ItemCode}</td>
                            <td>{order.ItemName}</td>
                            <td>{order.Necesario}</td>
                            <td>{order.NecesidadReal}</td>
                            <td>{order.Precio}</td>
                            <td>{order.FechaElaboracion}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const columns = [
        {
            name: "Proyecto",
            selector: (row) => row.Project,
            sortable: true,
            width: "200px",
        },
        {
            name: "Codigo SN",
            selector: (row) => row.CardCode,
            sortable: true,
            width: "150px",
        },
        {
            name: "Codigo Escuela",
            selector: (row) => row.CntctCode,
            sortable: true,
            width: "150px",
        },
        {
            name: "Institución",
            selector: (row) => row.Institucion,
            sortable: true,
            width: "400px",
        },
        {
            name: "Ruta",
            selector: (row) => row.Ruta,
            sortable: true,
            width: "300px",
        },
    ];

    // 📌 Función para generar JSON con la estructura correcta
    const generateJSON = () => {
        const payload = filteredOrders.map(order => ({
            "CardCode": order.CardCode,
            "ContactPersonCode": order.CntctCode,
            "DocDate": startDate || new Date().toISOString().split('T')[0],
            "DocDueDate": deliveryDate,
            "U_Ruteo": order.Ruta,
            "U_Mes": order.MesEntrega,
            "U_Semana": order.Semana,
            "U_Semanamenu": order.Semana,
            "U_distrito": order.Localidad,
            "U_InicioTras": startDate || "",
            "U_FinTras": endDate || "",
            "U_Serv": serviceType?.value || "",
            "U_Planif_Origen": "A",
            "DocumentLines": order.Orders.map(line => ({
                "ItemCode": line.ItemCode,
                "ItemDescription": line.ItemName,
                "ProjectCode": line.Project,
                "Quantity": line.Necesario,
                "WarehouseCode": line.Almacen,
                "PriceAfterVAT": line.Precio,
                "AgreementNo": line.Code,
                "U_FechaElab": line.FechaElaboracion,
                "U_Necesidad_Real": line.NecesidadReal,
                "U_FechaCarga": nestedDate
            }))
        }));
        return payload;
    };

    // 📌 Enviar JSON al backend
    const sendDataToBackend = async () => {
        const payload = generateJSON();
        console.log(payload);
        try {
            const response = await apiClient.post("/planif/insumos/ejecucion", { orders: payload }, { timeout: 600000 });
            
            if (response.status === 200) {
                alert("Datos enviados correctamente al backend.");
                // 🔹 Limpiar los campos después del envío exitoso
                setserviceType("");     // Limpia el campo de texto
                setproject("");     // Limpia el campo de proyecto
                setEndDate("");     // Limpia el campo de proyecto
                setEndRoute("");     // Limpia el campo de proyecto
                setStartDate("");     // Limpia el campo de proyecto
                setStartRoute("");     // Limpia el campo de proyecto
                setFilteredOrders([]); // Borra la tabla de datos
            } else {
                alert("Hubo un problema al enviar los datos.");
            }

        } catch (error) {
            console.error("Error al enviar los datos", error);
            alert("Error al enviar la solicitud.");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Ejecución de Insumos por Escuela</h2>

            {error && <div className="alert alert-danger">{error}</div>}
            <div className="row">
                <div className="col-md-3">
                    <label>Fecha Inicial:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Final:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Entrega:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={deliveryDate}
                        onChange={(e) => setdeliveryDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Recepcion:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={nestedDate}
                        onChange={(e) => setnestedDate(e.target.value)}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <label>Código de Proyecto:</label>
                    <Select
                        options={projects}
                        value={project}
                        onChange={setproject}
                        placeholder="Seleccione un proyecto..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-6">
                    <label>Código de Institución:</label>
                    <Select
                        options={schools}
                        value={school}
                        onChange={setSchool}
                        placeholder="Seleccione una institución..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Raciones:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={raciones}
                        onChange={(e) => setQuantity(e.target.value)}
                    />
                </div>
                
                
            </div>
            <div className="row">
                <div className="col-md-3">
                    <label>Tipo de Servicio:</label>
                    <Select
                        options={servicesType}
                        value={serviceType}
                        onChange={setserviceType}
                        placeholder="Seleccione un Servicio..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Ruta Inicial:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={start_route}
                        onChange={(e) => setStartRoute(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Ruta Final:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={end_route}
                        onChange={(e) => setEndRoute(e.target.value)}
                    />
                </div>
            </div>

            <button className="btn btn-success mt-2" onClick={fetchInsumos}>Planificar</button>
            <button className="btn btn-primary mt-2 ml-2" onClick={sendDataToBackend} disabled={loading || !setOrders} > {loading ? "Generando..." : "Migrar a SAP"}</button>
            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
            />
        </div>
    );
};

export default PlanifLines;
